import { DatePicker } from 'antd';
import moment from 'moment';

// Wrapper created to work with Javascript Date instead of momentjs (like antd)
export default function UniversalDatePicker(originalProps) {
  const props = { ...originalProps };
  if (props.value) {
    props.value = moment(props.value);
  }
  if (props.onChange) {
    const originalOnChange = props.onChange;
    props.onChange = (momentValue) => {
      originalOnChange(momentValue?.toDate());
    };
  }
  return <DatePicker {...props} />;
}
